import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { isEmpty, merge } from "@/commons/utils/functions";

var getDefaultState = function getDefaultState() {
  return {
    product: {},
    start_on_list: false,
    applicant: {
      numero_documento: {},
      info_extra: {}
    },
    company: {},
    identities: {},
    form_product: {
      garante: false,
      start_on_select: false,
      product_type_person: true,
      loan: null,
      monto: null,
      monto_cuota: null,
      plazo: null,
      tasa: null,
      primer_vencimiento: null,
      emision: null,
      ventas: null,
      cedula: null,
      jubilado: false,
      listablanca: null,
      current_step: null,
      verify_route: false
    },
    sucursal: false
  };
};

var state = getDefaultState();
var mutations = {
  SET_PRODUCT: function SET_PRODUCT(state, product) {
    state.product = product;

    if (product.tipo_de_prestamo == 2) {
      state.form_product.product_type_person = false;
    }
  },
  SET_FORM_PRODUCT: function SET_FORM_PRODUCT(state, data) {
    state.form_product = merge(state.form_product, data);
  },
  SET_START_ON_LIST: function SET_START_ON_LIST(state) {
    state.start_on_list = true;
  },
  SET_APPLICANT: function SET_APPLICANT(state, data) {
    state.applicant = merge(state.applicant, data);
  },
  SET_COMPANY: function SET_COMPANY(state, data) {
    state.company = merge(state.company, data);
  },
  SET_APPLICANT_IDENTITIES: function SET_APPLICANT_IDENTITIES(state, data) {
    if (Object.prototype.hasOwnProperty.call(data, "identity")) {
      state.identities[data.identity.document] = data.identity.number;
    }
  },
  RESSET_FORM_PRODUCT: function RESSET_FORM_PRODUCT(state) {
    state.form_product = getDefaultState().form_product;
  },
  RESSET_APPLICANT: function RESSET_APPLICANT(state) {
    state.applicant = getDefaultState().applicant;
  },
  RESSET_COMPANY: function RESSET_COMPANY(state) {
    state.applicant = getDefaultState().company;
  },
  START_ON_SELECT: function START_ON_SELECT() {
    state.start_on_select = true;
  },
  SET_SUCURSAL: function SET_SUCURSAL(state, data) {
    state.sucursal = data;
  }
};
var actions = {
  setProducto: function setProducto(_ref, product) {
    var commit = _ref.commit;
    commit('SET_PRODUCT', product);

    this._vm.$session.set('product', state.product);
  },
  setFormProduct: function setFormProduct(_ref2, client) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit;
              commit('SET_FORM_PRODUCT', client);

              _this._vm.$session.set('form_product', state.form_product);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  setStartOnList: function setStartOnList(_ref3) {
    var commit = _ref3.commit;
    commit('SET_START_ON_LIST');
  },
  setApplicant: function setApplicant(_ref4) {
    var commit = _ref4.commit;
    var client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    commit('SET_APPLICANT', client);

    this._vm.$session.set('applicant', state.applicant);
  },
  setCompany: function setCompany(_ref5) {
    var commit = _ref5.commit;
    var client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    commit('SET_COMPANY', client);

    this._vm.$session.set('company', state.company);
  },
  setApplicantIdentities: function setApplicantIdentities(_ref6) {
    var commit = _ref6.commit;
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    commit('SET_APPLICANT_IDENTITIES', data);
  },
  resetFormProduct: function resetFormProduct(_ref7) {
    var commit = _ref7.commit;
    commit('RESSET_FORM_PRODUCT');

    this._vm.$session.set('form_product', state.form_product);
  },
  resetApplicant: function resetApplicant(_ref8) {
    var commit = _ref8.commit;
    commit('RESSET_APPLICANT');

    this._vm.$session.set('applicant', state.applicant);
  },
  resetCompany: function resetCompany(_ref9) {
    var commit = _ref9.commit;
    commit('RESSET_COMPANY');

    this._vm.$session.set('company', state.company);
  },
  startOnSelect: function startOnSelect(_ref10) {
    var commit = _ref10.commit;
    commit('START_ON_SELECT');
  },
  validatePrecondition: function validatePrecondition(_ref11, precondition) {
    var state = _ref11.state;
    console.log('validatePrecondition');
    return !isEmpty(state.form_product[precondition]);
  },
  setSucursal: function setSucursal(_ref12, data) {
    var commit = _ref12.commit;
    commit('SET_SUCURSAL', data);

    this._vm.$session.set('sucursal', data);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};